import {Input} from "../Form/types";
import {createTextInput} from "../Form/Input";
import {__} from "@wordpress/i18n";

export const InputPhone = (el: HTMLElement|null) => {
    return el
        ? createTextInput( el as HTMLInputElement, ( input: Input, value: string ): void => {
            if ( ! /^\+?[0-9\s\-()]{7,20}$/.test( value.trim() ) ) {
                input.addError( __( 'Ungültige Telefonnummer.', 'dierck-group-company' ) );
            }
        } )
        : null;
}
